module.exports = __webpack_public_path__ + "img/father_and_son_fixing_bike@2x.71050afc.png";